import { render, staticRenderFns } from "./ModuleColumnScrollWrapper.vue?vue&type=template&id=3f870851"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports